import { useQuery } from '@apollo/client'
import PremiumLock from 'utils/premiumLock'
import type { CoverBookShelfProps } from 'components/modular/shelves/book-shelf/BookShelf.types'
import { post_event } from 'utils/analytics'
import { INTERMEDIATE_DETAILS_BOOK_PATH } from 'routes/paths'
import { runningRecordsBookshelvesQuery } from 'api/queries'
import { useHistory } from 'react-router-dom'
import { getBooksBadges } from 'utils/badges'
import type { LanguageTokens } from 'i18n'
import { useTranslation } from 'i18n'
import type { IRunningRecordsAssessmentBooksSuggested } from './runningRecordsBookShelf.types'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import { shouldUseNextjsBookIntermediate } from 'utils/identify-modules/IdentifyModules'

const ITEMS_TO_SHOW = 20
const CONTENT_FILTER = 'RECOMMENDED_RUNNING_RECORDS'

const useRunningRecordsBookShelf = () => {
  const { data, loading } = useQuery<IRunningRecordsAssessmentBooksSuggested>(
    runningRecordsBookshelvesQuery,
    {
      variables: {
        page: 1,
        perPage: ITEMS_TO_SHOW
      }
    }
  )

  const { user } = useUserInfo()
  const { t } = useTranslation()
  const history = useHistory()

  const onClickBook = (book: CoverBookShelfProps) => {
    if (book.premiumLock) {
      PremiumLock.sendBookClickEvent(book)
    }

    post_event(`Destaques/ClickCapaLivro/${CONTENT_FILTER}`, book.slug)
    if (shouldUseNextjsBookIntermediate()) {
      window.location.href = `/app-v2/book/intermediate/${book.slug}`
      return
    }
    history.push(INTERMEDIATE_DETAILS_BOOK_PATH(book.slug))
  }

  const onClickBtnGetMore = () => {
    post_event(`Destaques/ClickVerTudo/${CONTENT_FILTER}`, 'TRUE')
  }

  return {
    content:
      data?.me?.reader?.runningRecordsAssessmentBooksSuggested?.map(book => {
        const degree = getBooksBadges({ book: book, user })
        return {
          ...book,
          title: book.name,
          degreesRange: [
            {
              tagName: t(degree?.name as LanguageTokens),
              fullName: t(degree?.fullName as LanguageTokens)
            }
          ]
        }
      }) || [],
    loading,
    onClickBook,
    onClickBtnGetMore
  }
}

export { useRunningRecordsBookShelf }
